import type { DbUser } from '@core/models/user.model';

function record(obj: unknown): Record<string, unknown> | null {
  if (obj !== null && typeof obj === 'object') {
    return obj as Record<string, unknown>;
  }
  return null;
}

/**
 * Obtiene el cliente asociado al usuario de backoffice (no admin).
 * Tolera camelCase / snake_case y distintas formas de `clientAccess`.
 */
export function resolveActiveClientId(user: DbUser | null): string | null {
  if (!user) {
    return null;
  }
  const u = record(user);
  if (!u) {
    return null;
  }
  const direct = u['clientId'] ?? u['client_id'];
  if (direct !== undefined && direct !== null && String(direct) !== '') {
    return String(direct);
  }
  const access = u['clientAccess'] ?? u['client_access'];
  if (!Array.isArray(access) || access.length === 0) {
    return null;
  }
  const first = record(access[0]);
  if (!first) {
    return null;
  }
  const id = first['clientId'] ?? first['client_id'] ?? first['id'];
  if (id !== undefined && id !== null && String(id) !== '') {
    return String(id);
  }
  const nested = record(first['client']);
  const nestedId = nested?.['id'];
  if (nestedId !== undefined && nestedId !== null && String(nestedId) !== '') {
    return String(nestedId);
  }
  return null;
}
